import { gql } from 'graphql-request';

export const FEED_QUERY = gql`
  query Feed($limit: Int, $offset: Int) {
    feed(limit: $limit, offset: $offset) {
      id
      score
      tastingNotes
      brewType
      createdAt
      user {
        id
        name
        surname
        fullName
        profilePictureLocation
      }
      coffee {
        id
        name
        origin
        processingType
        varieties
        tastingNotes
        imageUrl
        roaster {
          id
          name
          location
          city
          countryCode
        }
      }
    }
  }
`;
